import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const jump = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0); }
`;

const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(10px); }
  20% { opacity: 1; transform: translateY(0); }
  80% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-10px); }
`;

const Container = styled.div`
  position: fixed;
  bottom: 40px;
  right: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${fadeInOut} 2.5s ease-in-out forwards;
`;

const Character = styled.div`
  font-size: 60px;
  animation: ${jump} 0.5s ease-in-out;
`;

const Message = styled.div`
  font-family: 'Montserrat', sans-serif;
  color: white;
  background: rgba(0, 0, 0, 0.7);
  padding: 8px 16px;
  border-radius: 20px;
  margin-top: 10px;
  font-size: 14px;
`;

const JapaneseText = styled.div`
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 12px;
  opacity: 0.8;
  margin-top: 4px;
`;

const SuccessAnimation = ({ onComplete }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      if (onComplete) onComplete();
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!show) return null;

  return (
    <Container>
      <Character>ʕ•ᴥ•ʔ</Character>
      <Message>
        Success!
        <JapaneseText>喜びが生まれました！</JapaneseText>
      </Message>
    </Container>
  );
};

export default SuccessAnimation; 